module.exports = __webpack_public_path__ + "static/media/23-2.ffd6ca79.mp3";